"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicTypesAsSvg = basicTypesAsSvg;
exports.default = void 0;
exports.elaboratedTypes = elaboratedTypes;
exports.elaboratedTypesAsSvg = elaboratedTypesAsSvg;
exports.getPowerUnitLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _ConvergenceIcon = _interopRequireDefault(require("../cic/styles/icons/react-icons/ConvergenceIcon"));
var getPowerUnitLabel = exports.getPowerUnitLabel = function getPowerUnitLabel(unit) {
  switch (unit) {
    // Kilovoltampere
    case 'KVA':
      return 'kVA';
    // Kilowatt
    case 'KW':
      return 'kW';
    // Kilowattstunde
    case 'KWH':
      return 'kWh';
    // Megawatt
    case 'MGW':
      return 'MW';
    // Milliwatt
    case 'MW':
      return 'mW';
    // Kubikmeter
    case 'M3':
      return 'm³';
    default:
      return unit;
  }
};
function elaboratedTypesAsSvg(division, text) {
  var divisionText = text[division];
  var icon;
  switch (division) {
    case 'CONSUMPTION_GAS':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_gas_18x18"
      });
      break;
    case 'CONSUMPTION_POWER':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_strom_18x18"
      });
      break;
    case 'FEEDIN_POWER_WATER':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-wasser_18x18",
        className: "asasd"
      });
      break;
    case 'FEEDIN_GAS':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-gas_18x18"
      });
      break;
    case 'FEEDIN_POWER':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-strom_18x18"
      });
      break;
    case 'FEEDIN_POWER_CHP_ACT':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-kwk_18x18"
      });
      break;
    case 'FEEDIN_POWER_BIOMASS':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_bio-gas_18x18"
      });
      break;
    case 'FEEDIN_POWER_WIND':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeisemanagement_18x18"
      });
      break;
    case 'FEEDIN_POWER_PHOTOELECTRIC':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_solar_18x18"
      });
      break;
    case 'FEEDIN_POWER_GEOTHERMAL':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_waerme_18x18"
      });
      break;
    default:
      icon = /*#__PURE__*/_react.default.createElement("span", null);
  }
  return {
    text: divisionText,
    icon: icon
  };
}
function elaboratedTypes(division, text) {
  var divisionText = text[division];
  var icon;
  switch (division) {
    case 'CONSUMPTION_GAS':
      icon = /*#__PURE__*/_react.default.createElement("div", {
        className: "energy-type__gas"
      });
      break;
    case 'CONSUMPTION_POWER':
      icon = /*#__PURE__*/_react.default.createElement("div", {
        className: "energy-type__power"
      });
      break;
    case 'FEEDIN_POWER_WATER':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-wasser_18x18",
        className: "asasd"
      });
      break;
    case 'FEEDIN_GAS':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-gas_18x18"
      });
      break;
    case 'FEEDIN_POWER':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-strom_18x18"
      });
      break;
    case 'FEEDIN_POWER_CHP_ACT':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeiser-kwk_18x18"
      });
      break;
    case 'FEEDIN_POWER_BIOMASS':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_bio-gas_18x18"
      });
      break;
    case 'FEEDIN_POWER_WIND':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_einspeisemanagement_18x18"
      });
      break;
    case 'FEEDIN_POWER_PHOTOELECTRIC':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_solar_18x18"
      });
      break;
    case 'FEEDIN_POWER_GEOTHERMAL':
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_waerme_18x18"
      });
      break;
    default:
      icon = /*#__PURE__*/_react.default.createElement("span", null);
  }
  return {
    text: divisionText,
    icon: icon
  };
}
function basicTypesAsSvg(division, divisionTextList) {
  var divisionText;
  var icon;
  switch (division) {
    case 'GAS':
      divisionText = divisionTextList.gasText;
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_gas_18x18"
      });
      break;
    case 'POWER':
      divisionText = divisionTextList.powerText;
      icon = /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
        size: "18",
        glyph: "icon_strom_18x18"
      });
      break;
    case 'CONVERGENCE':
      divisionText = divisionTextList.convergenceText;
      icon = /*#__PURE__*/_react.default.createElement(_ConvergenceIcon.default, null);
      break;
    default:
      divisionText = '';
      icon = '';
  }
  return {
    text: divisionText,
    icon: icon
  };
}
var _default = exports.default = function _default(division, divisionTextList) {
  var divisionText;
  var className;
  switch (division) {
    case 'GAS':
      divisionText = divisionTextList.gasText;
      className = 'loggedin-meter-energy-type__gas';
      break;
    case 'POWER':
      divisionText = divisionTextList.powerText;
      className = 'loggedin-meter-energy-type__power';
      break;
    case 'CONVERGENCE':
      divisionText = divisionTextList.convergenceText;
      className = 'loggedin-meter-energy-type__convergence';
      break;
    default:
      divisionText = '';
      className = '';
  }
  return {
    text: divisionText,
    className: className
  };
};